module.exports = __webpack_public_path__ + "a7d415adac6a836bf258839b12d242dc.MP3";